import type {Awaitable} from '~/types/utils';
import type {GetProductsParams, ProductCatalogProducts} from '~/services/productCatalog/types';
import ProductCatalogService from '~/services/productCatalog/ProductCatalogService';
import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

export default class ProductCatalogServiceFallbackWrapper<P extends ProductDetail> extends ProductCatalogService<P> {
	private service: ProductCatalogService<P>;
	private readonly getFallbackService: (e?: unknown) => Awaitable<ProductCatalogService<P>>;

	constructor(options: {
		service: ProductCatalogService<P>;
		getFallbackService: (e?: unknown) => Awaitable<ProductCatalogService<P>>;
	}) {
		super();
		this.service = options.service;
		this.getFallbackService = options.getFallbackService;
	}

	override get name() {
		return this.service.name;
	}

	override async getProducts(params: GetProductsParams): Promise<ProductCatalogProducts<P>> {
		try {
			return await this.service.getProducts(params);
		} catch (error) {
			if (import.meta.client) {
				console.error(error);
				console.info('Switching to fallback product catalog service.');
			}

			this.service.dispose();
			this.service = await this.getFallbackService(error);
			return await this.service.getProducts(params);
		}
	}

	override dispose() {
		this.service.dispose();
	}
}
